import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const ConflictDialog = ({ open, onReload, onClose, what = "record" }) => (
  <AlertDialog open={open} onOpenChange={(o) => !o && onClose()}>
    <AlertDialogContent data-testid="conflict-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Someone else changed this {what}</AlertDialogTitle>
        <AlertDialogDescription>
          Another employee saved changes to this {what} after you opened it. Your changes were <b>not</b> saved, so nothing was overwritten.
          Load the latest version, then make your change again.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="conflict-keep-btn">Keep my edits on screen</AlertDialogCancel>
        <AlertDialogAction onClick={onReload} className="bg-[#071434] hover:bg-[#0d1f4d]" data-testid="conflict-reload-btn">Load latest version</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
